import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appScrollInToView]',
  standalone: true
})
export class ScrollInToViewDirective {

  @Input()
  appScrollInToView: string | undefined;

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();

    document.getElementById(this.appScrollInToView || '')?.scrollIntoView({
      block: 'center',
      behavior: 'smooth'
    });
  }

}
